import {
    GPS_PLOT_API_SUCCESS,
    GPS_PLOT_API_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    data: null,
    loading: false,
    error: null,
};

const GpsPlot = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GPS_PLOT_API_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
                error: null,
            };

        case GPS_PLOT_API_FAIL:
            return {
                ...state,
                error: action.payload.error,
                loading: false,
            };

        default:
            return state;
    }
};

export default GpsPlot;
